var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInnovation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_117_1597)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 56C43.964 56 56.5 43.464 56.5 28C56.5 12.536 43.964 0 28.5 0C13.036 0 0.5 12.536 0.5 28C0.5 43.464 13.036 56 28.5 56Z",
    fill: "#F77B55"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_117_1597",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 57,
    height: 56
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 56C43.964 56 56.5 43.464 56.5 28C56.5 12.536 43.964 0 28.5 0C13.036 0 0.5 12.536 0.5 28C0.5 43.464 13.036 56 28.5 56Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_117_1597)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 22.7513C46 31.9322 38.5564 39.375 29.3759 39.375C20.1945 39.375 12.75 31.9322 12.75 22.7513C12.75 13.5686 20.1945 6.125 29.3759 6.125C38.5564 6.125 46 13.5686 46 22.7513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 22.75H21.5V35.875H12.75V22.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 35.875H8.375L12.75 24.5L14.5 35.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0625 45.5H13.625L12.75 35.875L37.25 34.125L35.0625 45.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9375 55.125L21.9375 60.375V44.1875L39.875 36.75L42.9375 55.125Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.75 42.4546L40.3125 39.8125L45.125 28L33.75 29.75V42.4546Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5625 47.25H27.1875L26.3125 46.375V45.5H32.4375V46.375L31.5625 47.25Z",
    fill: "#CCCBCA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 11.8125C23.3318 11.8125 18.4375 16.7068 18.4375 22.75C18.4347 24.3176 18.7704 25.8674 19.4217 27.2933C20.0729 28.7193 21.0243 29.9878 22.211 31.0122C22.2823 31.0686 22.3536 31.1281 22.4192 31.1881C24.0047 32.5881 24.5625 34.4697 24.5625 36.75V39.375H34.1875V36.75C34.1875 34.4697 34.7453 32.5881 36.3313 31.1881C36.3985 31.127 36.4678 31.0684 36.5391 31.0122C37.7258 29.9879 38.6774 28.7194 39.3286 27.2934C39.9799 25.8675 40.3155 24.3176 40.3125 22.75C40.3125 16.7068 35.4186 11.8125 29.375 11.8125Z",
    fill: "#FDCA5C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3125 45.5H25.4375L24.5625 44.625V39.375H34.1875V44.625L33.3125 45.5Z",
    fill: "#474F59"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.125 39.375H34.625M24.125 41.125H34.625M24.125 42.875H34.625",
    stroke: "#353F49",
    strokeWidth: 0.21875,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 30.625C33.7242 30.625 37.25 27.0992 37.25 22.75C37.25 18.4008 33.7242 14.875 29.375 14.875C25.0258 14.875 21.5 18.4008 21.5 22.75C21.5 27.0992 25.0258 30.625 29.375 30.625Z",
    fill: "#FFDB79"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 26.6875C31.5496 26.6875 33.3125 24.9246 33.3125 22.75C33.3125 20.5754 31.5496 18.8125 29.375 18.8125C27.2004 18.8125 25.4375 20.5754 25.4375 22.75C25.4375 24.9246 27.2004 26.6875 29.375 26.6875Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.75 28.875H28.5V38.9375H26.75V28.875Z",
    fill: "#FF916E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 28.875H30.25V38.9375H28.5V28.875Z",
    fill: "#F77B55"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.25 28.875H32V38.9375H30.25V28.875Z",
    fill: "#EE643C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 22.75L26.75 28.875H32L29.375 22.75Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 22.75L30.25 28.875H32L29.375 22.75Z",
    fill: "#CCCBCA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3751 22.75L28.438 24.9375H30.3127L29.3751 22.75Z",
    fill: "#474F59"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3126 24.9375L29.375 22.75L29.6878 24.9375H30.3126Z",
    fill: "#232E38"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.375 48.125V49M29.375 49.875V50.75M29.375 51.625V52.5M29.375 53.375V54.25M29.375 55.125V56",
    stroke: "#474F59",
    strokeWidth: 0.21875,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3759 9.1875V10.5M26.7299 9.44825L26.9858 10.7349M24.1854 10.2196L24.6876 11.4323M21.8408 11.4734L22.5697 12.5646M19.7854 13.16L20.7134 14.0875M18.0984 15.2149L19.1896 15.9438M16.845 17.5599L18.0573 18.0613M16.0728 20.1044L17.3604 20.3599M15.8125 22.75H17.125M32.0206 9.44825L31.7651 10.7349M34.5651 10.2196L34.0628 11.4323M36.9101 11.4734L36.1812 12.5646M38.965 13.16L38.0371 14.0875M40.6516 15.2149L39.5604 15.9438M41.9054 17.5599L40.6927 18.0613M42.6776 20.1044L41.3901 20.3599M42.9375 22.75H41.625",
    stroke: "#474F59",
    strokeWidth: 0.21875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_117_1597"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInnovation);
export default __webpack_public_path__ + "static/media/Innovation.d2e326c09beac6152997ef63df11232b.svg";
export { ForwardRef as ReactComponent };